import axios from 'axios'

const getOpponents = async oauthToken => {
  const response = await axios.get('/api/teamspirit/opponents', {
    headers: {
      'x-oauth-token': oauthToken,
    },
  })

  return response.data
}

const getGroups = async (oauthToken, nationalTeamId, {
  refresh = false,
  tournamentId = null,
  groupId = null,
  phase = null,
  includePreviousPhase = false,
} = {}) => {
  const response = await axios.get('/api/teamspirit/groups', {
    params: {
      nationalTeamId,
      refresh,
      tournamentId,
      groupId,
      phase,
      includePreviousPhase,
    },
    headers: {
      'x-oauth-token': oauthToken,
    },
  })

  return response.data
}

const saveManualChange = async (oauthToken, { teamId, matchId, attitude, spiritBefore, editorTeamId }) => {
  const response = await axios.put('/api/teamspirit/manual-changes', {
    teamId,
    matchId,
    editorTeamId,
    ...(attitude !== undefined ? { attitude } : {}),
    ...(spiritBefore !== undefined ? { spiritBefore } : {}),
  }, {
    headers: {
      'x-oauth-token': oauthToken,
    },
  })

  return response.data
}

const resetManualChange = async (oauthToken, { teamId, matchId, field, editorTeamId }) => {
  const response = await axios.delete(`/api/teamspirit/manual-changes/${matchId}/${field}`, {
    params: { teamId, editorTeamId },
    headers: { 'x-oauth-token': oauthToken },
  })
  return response.data
}

const simulateLatestRound = async (
  oauthToken,
  nationalTeamId,
  forceSimulations = false,
  targetGroup = null
) => {
  const response = await axios.post('/api/teamspirit/post-match-sync', {
    simulateOnly: true,
    nationalTeamId,
    forceSimulations,
    targetGroup,
  }, {
    headers: {
      'x-oauth-token': oauthToken,
    },
  })

  return response.data
}

const simulatePreviousPhase = async (oauthToken, nationalTeamId, targetGroup) => {
  const response = await axios.post('/api/teamspirit/post-match-sync', {
    simulatePreviousPhase: true,
    nationalTeamId,
    targetGroup,
  }, {
    headers: {
      'x-oauth-token': oauthToken,
    },
  })

  return response.data
}

const fetchLatestRoundSpirits = async (oauthToken, nationalTeamId) => {
  const response = await axios.post('/api/teamspirit/post-match-sync', {
    latestRoundSpiritsOnly: true,
    nationalTeamId,
  }, {
    headers: {
      'x-oauth-token': oauthToken,
    },
  })

  return response.data
}

export default {
  getOpponents,
  getGroups,
  saveManualChange,
  resetManualChange,
  simulateLatestRound,
  simulatePreviousPhase,
  fetchLatestRoundSpirits,
}
